import { Icon } from "@iconify/react/dist/iconify.js";
import { FormControl, TextField } from "@mui/material";
import React from "react";

const SearchBar = ({ value, setValue, width="100%", paddingTop, module }) => {
    return (
        <React.Fragment>
            <FormControl variant="filled" fullWidth style={{ marginTop: -5 }} >
                <TextField
                    // className="me-2 mx-2"
                    size="small"
                    value={value}
                    placeholder={`Search by ${module || ""}`}
                    variant="outlined"
                    InputProps={{
                        startAdornment: <Icon icon="ri-search-2-line" color="#7D7D7D" className="text-muted" width="20" height="20"></Icon>,
                    }}
                    onChange={(e) => setValue(e.target.value)}
                    sx={{
                         "& .MuiOutlinedInput-root": {
                            borderRadius: '16px',
                            paddingInline: "20px",
                            '&.Mui-focused fieldset': {
                                borderColor: '#D9D9D9', // Change this color to your desired focus color
                            },
                        },
                        width,
                        height: "30px",
                        paddingTop: paddingTop ? paddingTop : 0,   
                    }}
                    inputProps={
                        {
                            sx: {
                                '&::placeholder': {
                                    color: '#BDBDBD',
                                    fontSize: 14,
                                    opacity: 1,
                                },
                                padding: "8px"
                            },
                        }
                    }
                />
            </FormControl>
        </React.Fragment>
    );
};

export default SearchBar;
